export default "__VITE_ASSET__BjJp0KTr__"